/**
 * Adapted from Markus Oberlehner's "Dependency injection with functional component factories"
 * https://markus.oberlehner.net/blog/dependency-injection-in-vue-with-functional-component-factories/
 *
 * For some reason, using components that are wrapped in a FUNCTIONAL "container factory" with the router (as top level components)
 * cause weird things happen. Also any view with a router-outlet, when used on a route with children causes
 * an infinite loop of death when it attempts to render the child view inside of the router-outlet.
 * Using a non-functional "container factory" bypasses these side effects.
 */
// 

export default (Component, injectedProps) => ({

  instance: null,  

  // Proxy Vue router In-Component Guards to wrapped instance
  beforeRouteUpdate() { return this.proxyGuard('beforeRouteUpdate', ...arguments) },
  beforeRouteLeave() { return this.proxyGuard('beforeRouteLeave', ...arguments) },

  render(h) {
    const data = {
      props:  {...this.$attrs, ...injectedProps}, // Combine normal props passed in with the injected dependencies
      on: this.$listeners,
      scopedSlots: this.$scopedSlots, // this.$scopedSlots also contains slots since v2.6.0+
    }

    this.instance = h(Component, data)
    return this.instance
  },

  methods: {
    proxyGuard(guardType, to, from, next) {
      let instanceGuards = this.instance.componentInstance.$options[guardType]
      if(instanceGuards) {
        instanceGuards.forEach(fn => fn.apply(this.instance.componentInstance, [to, from, next]))
      }
      else {
        next()
      }
    }
  }
})